import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';
import { chatMessages as initialMessages } from '../mockData';

const LiveChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState(initialMessages);
  const [inputMessage, setInputMessage] = useState('');

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (inputMessage.trim()) {
      // Add user message
      const userMessage = {
        id: messages.length + 1,
        sender: 'user',
        message: inputMessage,
        timestamp: new Date().toISOString()
      };
      
      setMessages([...messages, userMessage]);
      setInputMessage('');

      // Mock bot response after 1 second
      setTimeout(() => {
        const botMessage = {
          id: messages.length + 2,
          sender: 'bot',
          message: "Thank you for your message. Our team will respond shortly.",
          timestamp: new Date().toISOString()
        };
        setMessages(prev => [...prev, botMessage]);
      }, 1000);
    }
  };

  return (
    <>
      {/* Chat Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="btn-primary"
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          zIndex: 999,
          width: '60px',
          height: '60px',
          minWidth: 'unset',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        aria-label="Toggle Chat"
      >
        {isOpen ? <X size={24} /> : <MessageCircle size={24} />}
      </button>

      {/* Chat Window */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            bottom: '100px',
            right: '24px',
            width: '350px',
            height: '500px',
            background: 'var(--bg-primary)',
            border: '1px solid var(--border-medium)',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 998,
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
          }}
        >
          {/* Chat Header */}
          <div style={{ 
            padding: '20px',
            borderBottom: '1px solid var(--border-light)',
            background: 'var(--bg-secondary)'
          }}>
            <h3 className="heading-3">SOLENNE Support</h3>
            <p className="body-small" style={{ color: 'var(--text-secondary)', marginTop: '4px' }}>
              We typically reply within minutes
            </p>
          </div>

          {/* Messages */}
          <div style={{ 
            flex: 1,
            overflowY: 'auto',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          }}>
            {messages.map(msg => (
              <div
                key={msg.id}
                style={{
                  alignSelf: msg.sender === 'user' ? 'flex-end' : 'flex-start',
                  maxWidth: '80%'
                }}
              >
                <div
                  style={{
                    padding: '12px 16px',
                    background: msg.sender === 'user' ? 'var(--interactive-base)' : 'var(--bg-secondary)',
                    color: msg.sender === 'user' ? 'var(--bg-primary)' : 'var(--text-primary)'
                  }}
                >
                  <p className="body-small">{msg.message}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Input */}
          <form
            onSubmit={handleSendMessage}
            style={{
              padding: '16px',
              borderTop: '1px solid var(--border-light)',
              display: 'flex',
              gap: '8px'
            }}
          >
            <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              placeholder="Type your message..."
              className="body-small"
              style={{
                flex: 1,
                padding: '12px',
                border: '1px solid var(--border-medium)',
                borderRadius: '0px',
                background: 'transparent',
                outline: 'none'
              }}
            />
            <button
              type="submit"
              className="btn-icon"
              style={{
                padding: '12px',
                background: 'var(--interactive-base)',
                color: 'var(--bg-primary)',
                border: 'none'
              }}
              aria-label="Send"
            >
              <Send size={16} />
            </button>
          </form>
        </div>
      )}
    </>
  );
};

export default LiveChat;
